<template>
  <div class="login">
     <nav-header></nav-header>
    <!-- 中间主体 -->
    <div class="wrapper">
      <div class="container">
        <!-- 表单容器 -->
        <div class="login-form">
          <!-- 头部 -->
          <h3>
            <span class="checked">账号登录</span>
          </h3>
          <!-- 主体 搜索框 -->
          <div class="input">
            <i class="iconfont icon-denglu"></i>
            <input type="text" placeholder="请输入账号" v-model="lUsername" />
          </div>
          <div class="input">
            <i class="iconfont icon-jinru"></i>
            <input type="text" placeholder="密码" v-model="lPassword" />
          </div>

          <!-- 登录按钮 -->
          <div class="btn-large">
            <a href="javascript:;" class="btn" @click="logo()">登录</a>
          </div>

          <!-- 提示 -->
          <div class="tips">
            <div class="reg" @click="goReg()">立即注册</div>
          </div>
        </div>
      </div>
    </div>
    <nav-footer></nav-footer>
  </div>
</template>

<script>
import NavFooter from "./../components/NavFooter";
import NavHeader from "./../components/NavHeader";
export default {
  name: "login",
  components: {NavFooter,NavHeader},
  data() {
    return {
      href: "index.html",
      // 用户名
      lUsername: "",
      // 密码
      lPassword: "",
      // 获取收费跳转参数
      k: this.$route.query.k,
      // 获取到 user 用户信息
      logo_user: JSON.parse(window.localStorage.getItem("user")),
    };
  },
  mounted() {
    document.title = "北京天美互娱科技有限公司";
  },
  methods: {
    // 登录逻辑
    logo() {
      if (this.k) {
        window.localStorage.setItem("state", "0");
        // this.$router.push({ path: "/ac1", query: { k: 1 } });
        this.$router.push({ path: "/", query: { k: 1 } });
        window.location.reload();
      } else if (this.lUsername !== this.logo_user.Username) {
        alert("用户名错误");
      } else if (this.lPassword !== this.logo_user.Password) {
        alert("密码错误");
      } else {
        window.localStorage.setItem("state", "0");
        this.$router.push("/");
        window.location.reload();
      }
    },
    goReg() {
      this.$router.push("/register");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
@import "./../assets/scss/button.scss";
.login {
  // margin-top: 80px;
  // header
  & > .container {
    height: 113px;
    img {
      width: auto;
      height: 100%;
    }
  }
  // 中间主体
  .wrapper {
    background: url("/imgs/ht.jpg") no-repeat center;
    background-size: cover;
    // background-color: pink;
    .container {
      height: 576px;
      // 表单容器
      .login-form {
        position: absolute;
        // left: 0;
        right: 0;
        bottom: 29px;
        width: 410px;
        height: 450px;
        background-color: #eee;
        box-sizing: border-box;
        padding-left: 31px;
        padding-right: 31px;

        // 头部
        h3 {
          line-height: 23px;
          font-size: 24px;
          text-align: center;
          margin: 40px auto 49px;
          // 左侧字体
          .checked {
            color: #888;
          }
          // 右侧字体
          .sep-line {
            margin: 0 32px;
          }
        }

        // input
        .input {
          display: inline-block;
          width: 348px;
          height: 50px;
          border: 1px solid #e5e5e5;
          margin-bottom: 20px;
          display: flex;
          i {
            width: 15%;
            height: 100%;
            /* background-color: pink; */
            display: inline-block;
            line-height: 44px;
            font-size: 31px;
            text-align: center;
            border-radius: 1px solid #666;
            border: 1px solid #ccc;
            background-color: #fff;
          }
          input {
            width: 80%;
            height: 100%;
            border: none;
            padding: 18px;
          }
        }

        // 登录按钮
        .btn {
          width: 100%;
          line-height: 50px;
          font-size: 16px;
          margin-top: 10px;
        }

        // 提示
        .tips {
          display: flex;
          justify-content: space-between;
          margin-top: 14px;
          cursor: pointer;
          font-size: 14px;
          .sms {
            color: #ff6600;
          }
          .reg {
            color: #999999;
            span {
              margin: 0 7px;
              color: #999999;
            }
          }
        }
      }
    }
  }
  .btn-large {
    margin-bottom: 20px;
    margin: 20px auto;
    // background: $colorZ;
  }
  .btn-large a {
    background-color: $colorZ;
  }
}
</style>
